import type { Ref } from 'vue';
import { trainingApi } from '@/entities/Training';
import { useExcelBlobExport } from '@/shared/lib';

interface UseTrainingExportParams {
  trainingId: () => number | null;
}

const ENTITY_LABEL = { singular: 'treinamento', plural: 'treinamentos' };

/**
 * Wires the view's export button to the training export route. The id is read
 * through a getter so a click always exports the training currently on screen.
 */
export function useTrainingExport({ trainingId }: UseTrainingExportParams): {
  handleExportToExcel: () => Promise<void>;
  isExporting: Ref<boolean>;
} {
  return useExcelBlobExport(() => {
    const id = trainingId();

    if (id === null) {
      return Promise.reject(new Error('Treinamento não carregado.'));
    }

    return trainingApi.exportTrainingExcel(id);
  }, ENTITY_LABEL);
}
